export const apiUrls = {
    "user_survey": "user_survey/",


    

    //surveyLog
    "survey_log": "surveyLog/",
    "edit_survey_log": "surveyLog/",
    "survey_log_detail": "surveyLog/",
    "create_survey_log": "surveyLog/store",

    //surveyLogDone
    "create_survey_log_question_done": "surveyLogQuestionDone/store",
    "survey_log_question_done": "surveyLogQuestionDone/",
    "delete_survey_log_question_done": "surveyLogQuestionDone/",


    //answer
    "answer_detail": "survey/answer/",

    //user
    "user_detail": "users/",

    //ticket
    "create_ticket": "ticket/store",
    "ticket_detail": "ticket/",

    //ticketAttachments
    "create_ticket_attachments": "tickets/ticketAttachments/store",
    "download_ticket_attachment_file": "tickets/ticketAttachments/download/",
    

    //answerShowInput
    "answer_show_input_detail": "",
}